export default __webpack_public_path__ + "static/developer-portal-9fc72bc94c89302e18bd4748704eed20.png";